"use client";

import { RefreshRouteOnSave as PayloadRefreshRouteOnSave } from "@payloadcms/live-preview-react";
import { useRouter } from "next/navigation";

/**
 * Bridges Payload's inline Live Preview to this server-rendered blog page.
 *
 * When an editor saves (including autosave) in the /cms admin, the admin posts a
 * message to the preview iframe; this component listens for it and re-runs the
 * server render via router.refresh(), so the draft — including server-only
 * pieces like the program-recommendation carousels — stays current.
 *
 * Rendered only on preview requests, so it is inert for public blog visitors.
 * `serverURL` must match the admin origin for the postMessage origin check.
 */
export function RefreshBlogPreview() {
  const router = useRouter();

  return (
    <PayloadRefreshRouteOnSave
      refresh={() => router.refresh()}
      serverURL={process.env.DREAM_PORTAL_URL ?? ""}
    />
  );
}
